import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { QuoteDto } from '../../dtos';
import { ApiError, LoadingIndicator, useFailedUpdateSnackbar, useSuccessfulUpdateSnackbar } from '../../Components/CoreLib/library';
import { useGetQuoteByIdQuery, useLazyGetCustomerByIdQuery, useUpdateQuoteGeneralUpdateMutation } from '../../store/generated/generatedApi';
import { QuoteForm } from '../../Components/Forms/QuoteForm';

export const EditQuoteView: FC = () => {
    const { customerId, quoteId } = useParams();
    const navigate = useNavigate();
    const [getCustomer, { data: customer, isLoading: isCustomerLoading }] = useLazyGetCustomerByIdQuery();
    const { data, isLoading, error, refetch } = useGetQuoteByIdQuery({ id: quoteId! });
    const [updateQuote, { isSuccess, isError, reset }] = useUpdateQuoteGeneralUpdateMutation();

    useEffect(() => {
        if (customerId && !customer) {
            getCustomer({ id: customerId! });
        }
    }, [customer, customerId, getCustomer]);

    useSuccessfulUpdateSnackbar('Quote', isSuccess, reset);
    useFailedUpdateSnackbar('quote', isError, reset);

    const handleSave = async (values: QuoteDto) => {
        await updateQuote(values).unwrap();
        return values;
    };

    const handleCancel = () => {
        if (customerId) {
            navigate(`/customer/${customerId}/dashboard`);
        } else {
            navigate('/quotes');
        }
    };

    if (isLoading || isCustomerLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <QuoteForm save={handleSave} cancel={handleCancel} initValues={data} customer={customer} />;
};
